import { createVueWait } from "@chronotruck/vue-wait";

export const VueWait = createVueWait({
  registerComponent: false, // not registering `v-wait` component
});
